module.exports = __webpack_public_path__ + "static/media/19ESCAP38.cf343799.jpg";